<template>
  <div class="flex gap-2">
    <div
      class="max-w-[400px] min-w-[150px] flex items-center relative mx-2 search-wrap"
    >
      <div class="flex items-center absolute h-full search-icon">
        <fluent-icon
          icon="search"
          class="h-5 leading-9 text-sm text-slate-700 dark:text-slate-200"
        />
      </div>
      <input
        type="text"
        :placeholder="$t('AUDIT_LOGS.SEARCH_INPUT_PLACEHOLDER')"
        class="contact-search border-slate-100 dark:border-slate-600"
        :value="searchQuery"
        @keyup.enter="submitSearch"
        @input="inputSearch"
      />
      <woot-button
        :is-loading="false"
        class="clear"
        :class-names="searchButtonClass"
        @click="submitSearch"
      >
        {{ $t('AUDIT_LOGS.SEARCH_BUTTON') }}
      </woot-button>
    </div>
    <div class="relative">
      <div
        v-if="hasAppliedFilters"
        class="absolute h-2 w-2 top-1 right-3 bg-green-500 dark:bg-green-500 rounded-full"
      />
      <woot-button
        class="clear"
        color-scheme="secondary"
        data-testid="auditlogs-filter-button"
        icon="filter"
        @click="toggleFilter"
      >
        {{ $t('AUDIT_LOGS.FILTER') }}
      </woot-button>
    </div>
    <div class="relative">
      <woot-button
        color-scheme="info"
        class="clear"
        icon="ion-android-download"
        :is-loading="uiFlags.isDownloading"
        :disabled="uiFlags.isDownloading"
        @click="exportAuditLogs"
      >
        {{
          uiFlags.isDownloading
            ? $t('AUDIT_LOGS.EXPORTING')
            : $t('AUDIT_LOGS.EXPORT')
        }}
      </woot-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters({
      getAppliedAuditlogsFilters: 'auditlogs/getAppliedAuditlogsFilters',
      getSearchQuery: 'auditlogs/getSearchQuery',
      getExportType: 'auditlogs/getCurrentExportType',
      uiFlags: 'auditlogs/getUIFlags',
    }),
    hasAppliedFilters() {
      return this.getAppliedAuditlogsFilters.length;
    },
    searchButtonClass() {
      return this.searchQuery !== '' ? 'show' : '';
    },
  },
  mounted() {
    this.searchQuery = this.getSearchQuery;
  },
  methods: {
    toggleFilter() {
      this.$root.$emit('openAuditFiltersModal');
    },
    submitSearch() {
      this.$root.$emit('onSubmitSearch');
    },
    inputSearch(e) {
      this.$store.commit(
        'auditlogs/SET_AUDIT_LOGS_SEARCH_QUERY',
        e.target.value
      );
      this.searchQuery = e.target.value;
    },
    async exportAuditLogs() {
      try {
        if (this.getExportType === 'search') {
          await this.$store.dispatch('auditlogs/downloadAuditLogs', {
            queryPayload: {
              payload: { q: this.getSearchQuery },
              export_type: this.getExportType,
            },
          });
        } else {
          const queryPayload =
            this.$store.getters['auditlogs/getCurrentFilterQuery'];

          await this.$store.dispatch('auditlogs/downloadAuditLogs', {
            queryPayload: {
              ...queryPayload,
              export_type: this.getExportType,
            },
          });
        }

        this.showAlert(this.$t('AUDIT_LOGS.EXPORT_SUCCESS'));
      } catch (error) {
        this.showAlert(error?.message || this.$t('AUDIT_LOGS.EXPORT_ERROR'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~widget/assets/scss/variables';

.search-wrap {
  .contact-search {
    @apply pl-9 pr-[3.75rem] text-sm w-full h-[2.375rem] m-0;
  }

  .search-icon {
    @apply left-2.5;
  }

  .button {
    transition: transform 100ms linear;
    @apply ml-2 h-8 right-1 absolute py-0 px-2 opacity-0 -translate-x-px invisible;
  }

  .button.show {
    @apply opacity-100 translate-x-0 visible;
  }
}

[dir='rtl'] {
  .search-wrap {
    .contact-search {
      @apply pr-9 pl-[3.75rem] text-sm w-full h-[2.375rem] m-0;
    }

    .search-icon {
      @apply right-2.5;
      left: unset;
    }

    .button {
      transition: transform 100ms linear;
      @apply mr-2 h-8 -left-1 absolute py-0 px-2 opacity-0 -translate-x-px invisible min-w-[63px];
      right: unset;
    }

    .button.show {
      @apply opacity-100 translate-x-0 visible;
    }
  }
}
</style>
